import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns:${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  margin-right: ${(props) => (props?.marginRight ? props.marginRight : "0px")};
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "0px")};
  margin-left: ${(props) => (props?.marginLeft ? props.marginLeft : "0px")};
  margin-bottom: ${(props) =>
    props?.marginBottom ? props.marginBottom : "0px"};
}
`;

export const EnquiryHeaderWrapper = styled.div`
  background-color: ${(props) =>
    props?.backgroundColor ? props.backgroundColor : "#008395"};
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-radius: 5px 5px 0px 0px;
  margin-bottom: 5px;
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "0px")};
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const ServiceSection = styled.div`
  margin-top: 0px;
  padding-bottom: 5px;
  padding-left: 10px;
  background-color: ${(props) => (props?.color ? props.color : "#fff")};
`;

export const Separator = styled.hr`
  background: #ededed;
  border: 1px solid #ededed;
  width: auto;
  margin-top: 15px !important;
  margin-bottom: 0px !important;
  margin-left: -9px;
`;

export const SellingPriceLabel = styled.span`
  position: relative;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #0a4986;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  text-transform: initial;
  margin: 0px 0 6px 0;
`;

export const MarginDiv = styled.section`
  margin-left: ${(props) => (props?.marginLeft ? props.marginLeft : "0px")};
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "0px")};
`;

export const GrayDarkerServiceSpan = styled.span`
  color: ${(props) => props?.color};
  position: relative;
  font-weight: ${(props) => (props?.weight ? props.weight : "400")};
  ::before {
    position: absolute;
    content: "";
    display: block;
    height: 60px;
    width: 30px;
    left: -36px;
    background: radial-gradient(circle, #0a4986 10%, transparent 10%), 8px;
    background-size: 40px 20px;
    background-repeat: no-repeat;
  }
`;

export const GraySpan = styled.span`
  color: #767676;
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "left")};
  justify-self: ${(props) => (props?.textAlign ? props.textAlign : "left")};
`;

export const GrayDarkerSpan = styled.span`
  color: ${(props) => (props?.color ? props.color : "#474747")};
  font-weight: ${(props) => (props?.weight ? props.weight : "400")};
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "left")};
`;

export const EnquiryIdHyphen = styled.span`
  text-decoration: ${(props) => props.decoration ?? "underline"};
  cursor: pointer;
  color: ${(props) => props.color ?? "#fff"};
`;

export const HeaderWrapperTable = styled.div`
  background-color: #d1e6f7;
  display: table-column-group;
  justify-content: space-between;
  padding: 10px;
  border-radius: 5px 5px 0px 0px;
`;

export const HeaderText = styled.span`
  color: #fff;
  text-align: ${(props) =>
    props?.textAlign ? props.textAlign : "left"} !important;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: right;
`;

export const ActionDiv = styled.div`
  justify-items: right;
  justify-content: right;
  justify-self: right;
  display: flex;
  margin-top: 6px;
`;

export const QuoteServiceInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const QuoteServicePadding = styled.section`
  padding: ${(props) => props.padding ?? "20px"};
`;

export const MargingDiv = styled.div`
  background-color: ${(props) =>
    props?.backgroundColor ? props.backgroundColor : "#3EBBB933"};
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  display: block;
  font-size: 16px;
  font-weight: 700;
  text-align: right;
`;

export const MarginGridSubItem = styled.div`
  color: ${(props) => props.color ?? "#474747"};
  font-weight: ${(props) => props.weight ?? "700"};
  font-size: 16px;
  text-align: right;
`;

export const ServiceInfo = styled.div`
  justify-self: auto;
  color: ${(props) => props?.color ?? "#767676"};
  font-size: ${(props) => props?.fontSize ?? "14px"};
  font-weight: bold !important;
  padding-left: 4px;
`;

export const ExchangeRateConatiner = styled.div`
  display: flex;
`;

export const ExchangeRateLabel = styled.span`
  display: flex;
  padding: 8px;
  color: ${(props) => props?.color ?? "#f08046"};
`;
